import React, { useEffect } from "react";
import { Image, ImageSourcePropType, Pressable, View } from "react-native";
import Animated, {
  useAnimatedStyle,
  useSharedValue,
  withRepeat,
  withSpring,
  withTiming,
} from "react-native-reanimated";
import { useSounds } from "../../hooks/useSounds";
import { OFFSET_DEFAULT, OFFSET_PLAYING, styles } from "./styles";

// @ts-ignore ts(80005)
const STRAP_IMAGE = require("../../assets/images/strap.png");

interface Props {
  source: ImageSourcePropType;
  speed: number;
  isRotateRight: boolean;
  isPlaying: boolean;
  onPress: () => void;
}

export const Yoyo: React.FC<Props> = ({
  source,
  speed,
  isRotateRight,
  isPlaying,
  onPress,
}) => {
  const sounds = useSounds();

  const offset = useSharedValue(0);
  const rotation = useSharedValue(0);

  const strapAnimatedStyle = useAnimatedStyle(() => {
    return {
      height: withSpring(offset.value, {
        damping: 20,
        stiffness: 90,
      }),
    };
  });

  const yoyoAnimatedStyle = useAnimatedStyle(() => {
    return {
      transform: [
        {
          translateY: withSpring(offset.value, {
            damping: 20,
            stiffness: 90,
          }),
        },
        {
          rotateZ: `${rotation.value}deg`,
        },
      ],
    };
  });

  const sleep = (ms: number) =>
    new Promise((resolve) => setTimeout(resolve, ms));

  const play = () => {
    sounds.play("rotation", true);
    offset.value = OFFSET_PLAYING;
    rotation.value = withRepeat(
      withTiming(isRotateRight ? 360 : -360, {
        duration: 200 / speed,
      }),
      -1,
      false
    );
  };

  const stop = () => {
    sounds.stop("rotation");
    offset.value = OFFSET_DEFAULT;
    rotation.value = withSpring(0);
  };

  useEffect(() => {
    if (isPlaying) {
      play();
    } else {
      stop();
    }
  }, [isPlaying]);

  useEffect(() => {
    if (isPlaying) {
      (async () => {
        stop();
        await sleep(500);
        play();
      })();
    }
  }, [speed, isRotateRight]);

  return (
    <>
      {/* 糸 */}
      <Animated.Image
        style={[styles.strap, styles.absolute, strapAnimatedStyle]}
        source={STRAP_IMAGE}
        resizeMode="stretch"
      />
      {/* ヨーヨー本体 */}
      <Animated.View style={[styles.absolute, yoyoAnimatedStyle]}>
        <Pressable onPressIn={onPress}>
          <View style={styles.yoyoCircle}>
            <Image
              style={styles.yoyoImage}
              source={source}
              resizeMode="cover"
            />
          </View>
        </Pressable>
      </Animated.View>
    </>
  );
};
